import { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { plateformSettingServices } from "../../../APIServices/PasswordManagement/plateformSettingServices";
import Swal from "sweetalert2";
import { BiReset } from "react-icons/bi";

const SidebarSettings = ({ auth, getSinglePlateformSettings, plateformSettings, currentUserData }) => {
  const [sidebarSettings, setSidebarSettings] = useState("");
  const [loader, setLoader] = useState("");

  const addUpdatePlateformSettings = async (type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${type} sidebar setting?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(type);
        let userData = {};
        userData.sidebarSettings = type === "update" ? sidebarSettings : {};
        let data = await plateformSettingServices.addUpdatePlateformSettings(
          auth,
          userData
        );
        if (data?.statusCode === 200) {
          getSinglePlateformSettings();
        }
        setLoader("");
      }
    });
  };

  useEffect(() => {
    if (plateformSettings) {
      setSidebarSettings(
        plateformSettings?.settings?.sidebarSettings || ""
      );
    }
  }, [plateformSettings]);

  const hasLoginAccount = Boolean(currentUserData?.loginAccountId);

  const GROUPS = {
    quickAccess: {
      label: "Quick Access",
      key: "quickAccess",
      children: [
        { label: "All Items", key: "allItems" },
        { label: "Favorites", key: "favorites" },
        { label: "Secure Scan", key: "secureScan" },
        { label: "Secure Eye", key: "secureEye" },
        { label: "Tools", key: "tools" },
      ],
    },

    collaboration: {
      label: "Collaboration",
      key: "collaboration",
      children: [
        ...(hasLoginAccount ? [{ label: "Members", key: "member" }] : []),
        { label: "Invitation", key: "invitedMember" },
      ],
    },

    category: {
      label: "Categories",
      key: "category",
      children: [],
    },

    vaults: {
      label: "Vaults",
      key: "vaults",
      children: [
        { label: "Personal", key: "personal" },
        ...(hasLoginAccount ? [{ label: "Groups", key: "group" }] : []),
        { label: "Shared with Me", key: "sharedWithMe" },
        { label: "Shared by Me", key: "sharedByMe" },
      ],
    },

    system: {
      label: "System",
      key: "system",
      children: [
        { label: "Trash", key: "trash" },
        { label: "Archive", key: "archive" },
      ],
    },
  };

  const getGroups = (myFdata) => {
    return {
      ...GROUPS,
      quickAccess: {
        ...GROUPS.quickAccess,
        children: GROUPS.quickAccess.children.filter(
          item => !(item.key === "favorites" && myFdata === false)
        ),
      },
    };
  };

  const handleParentChange = (group) => {
    const issidebarSettings = !sidebarSettings[group.key];

    const updates = {
      [group.key]: issidebarSettings,
    };

    group.children.forEach((child) => {
      updates[child.key] = issidebarSettings;
    });

    setSidebarSettings((prev) => ({ ...prev, ...updates }));
  };

  const handleChildChange = (group, childKey) => {
    setSidebarSettings((prev) => {
      const updatedChildValue = !prev[childKey];
      const updatedState = {
        ...prev,
        [childKey]: updatedChildValue,
      };
      const allChildrenChecked = group.children.every(
        (child) =>
          child.key === childKey
            ? updatedChildValue
            : updatedState[child.key]
      );
      updatedState[group.key] = allChildrenChecked;
      return updatedState;
    });
  };

  let noUpdate = Object.values(plateformSettings?.settings?.sidebarSettings).every(value => value === false);
  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Sidebar Settings</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <Form.Group className="mb-2" style={{ fontSize: 13 }}>
                {Object.values(getGroups(!plateformSettings?.settings?.showSidebarSettings?.favorites)).map((group) => (
                  <div key={group.key} style={{ marginBottom: 10 }}>
                    <Form.Check
                      type="checkbox"
                      className="fw-bold"
                      label={group.label}
                      checked={sidebarSettings[group.key]}
                      onChange={() => handleParentChange(group)}
                    />
                    <div style={{ paddingLeft: 20 }}>
                      {group.children.map((child) => (
                        <Form.Check
                          key={child.key}
                          type="checkbox"
                          label={child.label}
                          checked={sidebarSettings[child.key]}
                          disabled={sidebarSettings[group.key]}
                          onChange={() => handleChildChange(group, child.key)}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </Form.Group>
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                If the checkbox is checked, the related options will be hidden; otherwise, when it is unchecked, the options will be visible on the platform.
              </Form.Label>
              <div className="hstack justify-content-end gap-2">
                {!noUpdate &&
                  <Button
                    disabled={loader}
                    onClick={() => addUpdatePlateformSettings("reset")}
                    variant="outline-danger"
                    style={{ fontSize: 13 }}
                    title="Reset"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BiReset /> Reset
                  </Button>
                }
                <Button
                  disabled={loader}
                  onClick={() => addUpdatePlateformSettings("update")}
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Update"
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <FaRegEdit /> Update
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SidebarSettings;
